module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row center-xs"
  }, [_c('pl-button', {
    staticClass: "col-xs",
    staticStyle: {
      "font-size": "28px",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitTeacher.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "padding-left": "10px",
      "padding-bottom": "10px"
    },
    attrs: {
      "src": "/static/teacher_icons/teacher_sign_up_black.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n      TEACHER\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "vertical-line",
    staticStyle: {
      "margin-left": "30px",
      "margin-right": "30px"
    }
  }), _vm._v(" "), _c('pl-button', {
    staticClass: "col-xs",
    staticStyle: {
      "font-size": "28px",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitStudent.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "padding-left": "10px",
      "padding-bottom": "10px"
    },
    attrs: {
      "src": "/static/student_icons/student_sign_up_black.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n      STUDENT\n    ")])], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs"
  }, [_c('span', {
    staticClass: "col-xs-12 center-xs pl-subheading",
    staticStyle: {
      "margin-bottom": "40px",
      "font-size": "40px",
      "color": "black"
    }
  }, [_vm._v("\n      I am a...\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs"
  }, [_c('div', {
    staticClass: "col-xs-7 pt4"
  }, [_c('span', {
    staticClass: "b"
  }, [_vm._v("Note: ")]), _vm._v(" "), _c('span', {
    staticClass: "i"
  }, [_vm._v("\n        If you are a teacher and joining a discussion in a PD session, you\n        should still create a teacher account.\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-cd0a2a0c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/chooseRole.vue
// module id = 2338
// module chunks = 61